import { IFrameNavButton } from "../atoms/IFrameNavButton";
import { useMessagesAdapter } from "adapters/messages";

const MessagesButton = () => {
  const props = useMessagesAdapter("button");
  return <IFrameNavButton {...props} />;
};

export { MessagesButton };
